export default __webpack_public_path__ + "static/media/dego-screenshot-04.f6f71f22.png";